import { normalizePolicyString, policyMatches } from '@/lib/policies';

const CANDIDATE_ROUTE_POLICY_OVERRIDES: Record<string, string[]> = {
  'covid-vaccine': ['program:candidate~full'],
  'influenza-vaccine': ['program:candidate~full'],
  'monkeypox-vaccine': ['program:candidate~full'],
  inrep: ['tools:inrepaccess~full'],
  'progress-report': ['tools:progressreportaccess~full']
};

const CANDIDATE_ROUTE_DASHBOARD_POLICY_MAP: Record<string, string> = {
  mist: 'program:candidate~full',
  fist: 'program:candidate~full',
  dsh: 'program:candidate~full',
  lead: 'program:candidate~full',
  maternal: 'program:candidate~full',
  odr: 'program:candidate~full',
  olive: 'program:candidate~full',
  'olive-vista': 'program:candidate~full',
  covid: 'program:candidate~full',
  'covid-testing': 'program:candidate~full',
  lai: 'tools:lai:jail~read',
  'lai-community': 'program:candidate~full',
  'charges-manager': 'program:candidate~full'
};

export const getCandidateRoutePolicies = (path: string): string[] => {
  const value = `${path || ''}`.trim();
  if (!value.startsWith('/candidates/')) {
    return [];
  }

  const candidateProgram = value.split('/')[2] || '';
  const overridePolicies = CANDIDATE_ROUTE_POLICY_OVERRIDES[candidateProgram];
  if (overridePolicies) {
    return overridePolicies;
  }

  const dashboardPolicy = CANDIDATE_ROUTE_DASHBOARD_POLICY_MAP[candidateProgram];
  if (!dashboardPolicy) {
    return [];
  }

  return [dashboardPolicy];
};

const hasGlobalWildcardResource = (resourceParts: string[]): boolean => {
  if (resourceParts.length === 0) {
    return false;
  }

  return resourceParts.every((part) => part === '*');
};

export const candidatePolicyMatches = (userPolicy: string, requiredPolicy: string): boolean => {
  if (!policyMatches(userPolicy, requiredPolicy)) {
    return false;
  }

  const [userResource = ''] = normalizePolicyString(userPolicy).split('~');
  const [requiredResource = ''] = normalizePolicyString(requiredPolicy).split('~');
  const userResourceParts = userResource.split(':').filter(Boolean);
  const requiredResourceParts = requiredResource.split(':').filter(Boolean);

  if (userResourceParts.length >= requiredResourceParts.length) {
    return true;
  }

  return hasGlobalWildcardResource(userResourceParts);
};
